module.exports = __webpack_public_path__ + "static/media/strava-clone.5f13a534.gif";